(function () {
  'use strict';

  var targets = [
    ['[data-stat="customers"]', 100000, 2800],
    ['[data-stat="designs"]', 1000, 2200],
    ['[data-stat="sold"]', 1000000, 3800],
    ['[data-stat="followers"]', 210000, 3200],
  ];

  function formatStat(n, final) {
    var s = n.toLocaleString('en-IN');
    return final ? s + '+' : s;
  }

  function animateCount(el, end, duration) {
    if (!el) return;
    var start = 0;
    var startTime = null;
    function step(ts) {
      if (startTime === null) startTime = ts;
      var t = Math.min(1, (ts - startTime) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var val = Math.floor(start + (end - start) * eased);
      el.textContent = formatStat(val, t >= 1);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initStats() {
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (row) {
        var el = document.querySelector(row[0]);
        if (el) el.textContent = formatStat(row[1], true);
      });
      return;
    }
    var seen = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || seen) return;
          seen = true;
          targets.forEach(function (row) {
            var el = document.querySelector(row[0]);
            animateCount(el, row[1], row[2]);
          });
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
    );
    var section = document.querySelector('.snt-stats-section');
    if (section) observer.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStats);
  } else {
    initStats();
  }
})();
